// src/components/PhaseDetails/service.ts
import { apiService } from '@/services/api';
import type { GridViewResponse, GridViewRequestParams } from '@components/GridView/types';

class PhaseDetailsService
{
  /**
   * Fetch conversations for the Phase Details view.
   * POST api/Conversation/GetPhaseDetailsConversations
   * Each conversation in the response can have ConversationPhaseId and CoreTaskPhaseId.
   */
  async getPhaseDetailsConversations(params: GridViewRequestParams): Promise<GridViewResponse>
  {
    try
    {
      const response = await apiService.post<GridViewResponse>(
        'Conversation/GetPhaseDetailsConversations',
        params,
      );
      return response ?? { Conversations: [] };
    }
    catch (error)
    {
      console.error('Error getting phase details conversations:', error);
      return { Conversations: [] };
    }
  }
}

export const phaseDetailsService = new PhaseDetailsService();
